import { useContext } from 'react';

import { stateContext } from '../../shared/contexts';
import { ECustomerTypeSelection } from '../../shared/types';
import { formatName } from '../utils';
import { useCustomerProfile } from './useCustomerProfile';

export function useCustomerReview() {
  const { selectedCustomerType, existingCustomer, newCustomer } = useContext(stateContext);
  const { data } = useCustomerProfile();
  if (selectedCustomerType === ECustomerTypeSelection.ExistingCustomer) {
    return `${existingCustomer?.firstName} ${existingCustomer?.lastName}`;
  }
  if (selectedCustomerType === ECustomerTypeSelection.NewCustomer) {
    return formatName(newCustomer?.firstName, newCustomer?.surname);
  }

  return formatName(data?.firstName, data?.lastName);
}
